<template>
  <div>
    <div id="dropdown" />
    <div class="flex flex-col min-h-screen bg-gray-100">
      <!-- Top Navbar -->
      <div class="bg-indigo-200 shadow">
        <div class="container flex items-center justify-between mx-auto px-6 py-3">
          <!-- Logo -->
          <Link href="/">
            <img
              src="/logo_yeu.png"
              class="w-auto h-8"
              alt="YEU Logo">
          </Link>

          <!-- User Menu -->
          <dropdown
            v-if="auth.user"
            class="mt-1"
            placement="bottom-end">
            <template #default>
              <div class="group flex items-center cursor-pointer select-none">
                <div class="mr-1 text-gray-800 group-hover:text-indigo-600 focus:text-indigo-600 whitespace-nowrap">
                  <span>{{ auth.user?.first_name }}</span>
                </div>
                <icon class="w-5 h-5 fill-gray-800 group-hover:fill-indigo-600 focus:fill-indigo-600" name="cheveron-down" />
              </div>
            </template>
            <template #dropdown>
              <div class="mt-2 py-2 text-sm bg-white rounded shadow-xl">
                <Link class="block px-6 py-2 hover:text-white hover:bg-indigo-500" href="/profile">
                  My Profile
                </Link>
                <Link
                  v-if="auth.user?.can?.manage_users"
                  class="block px-6 py-2 hover:text-white hover:bg-indigo-500"
                  href="/users">
                  Manage Users
                </Link>
                <Link
                  class="block px-6 py-2 w-full text-left hover:text-white hover:bg-indigo-500"
                  href="/logout"
                  method="delete"
                  as="button">
                  Logout
                </Link>
              </div>
            </template>
          </dropdown>

          <!-- Login Button for Guests -->
          <div v-else>
            <Link class="text-gray-800 hover:text-indigo-600 text-sm font-medium" href="/login">
              Login
            </Link>
          </div>
        </div>
      </div>

      <!-- Main Content -->
      <main class="container flex-grow mx-auto p-4 md:p-6">
        <flash-messages />
        <slot />
      </main>

      <!-- Footer -->
      <footer class="py-4 text-center text-gray-600 text-xs italic">
        <span>Build version: {{ version }}</span>
      </footer>
    </div>
  </div>
</template>

<script>
import { Link } from '@inertiajs/vue3'
import Icon from '@/Shared/Icon.vue'
import Dropdown from '@/Shared/Dropdown.vue'
import FlashMessages from '@/Shared/FlashMessages.vue'

export default {
    components: {
        Dropdown,
        FlashMessages,
        Icon,
        Link,
    },
    props: {
        auth: Object,
        version: String,
    },
}
</script>
